import React, { useEffect, useState } from 'react';
import { Tab, Tabs, styled, useMediaQuery, useTheme } from '@material-ui/core';
import { SmallerCard } from 'components/Cards/SmallerCard';
import { breakoutRoomInviteModel } from 'entities/breakoutRoomInviteModel';
import { FixedSizeList } from 'react-window';

const tabs = {
  INVITED: 'invited',
  ATTENDING: 'attending',
  NOT_INVITED: 'withoutTicket',
};

const ListContainer = styled('div')({
  // Handel scrollbar properties
  height: '100%',
  width: '100%',
  marginBottom: 30,
  padding: '8px 0',
  overflow: 'auto',
  '& > div::-webkit-scrollbar': {
    width: 6,
  },
  '& > div::-webkit-scrollbar-track': {
    background: '#ffffff',
  },
  '& > div::-webkit-scrollbar-thumb': {
    background: 'rgba(149, 152, 154, 0.43)',
    borderRadius: 5,
  },
  '& > div::-webkit-scrollbar-thumb:hover': {
    background: 'rgba(149, 152, 154, 1)',
  },
});

const listDimensions = {
  small: {
    itemSize: 75,
    listMinCount: 4,
  },
  big: {
    itemSize: 108,
    listMinCount: 3,
  },
};

function InvitationList({
  items,
  onDelete,
  onShowNote,
  onBan,
  onPromote,
  onRoleEdit,
  i18n,
  isOnlyViewMode,
}) {
  const mediaTheme = useTheme();
  const is320Down = useMediaQuery(mediaTheme.breakpoints.down(321));
  const isXsDown = useMediaQuery(mediaTheme.breakpoints.down('xs'));
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));

  const [selectedTab, setSelectedTab] = useState(tabs.INVITED);
  const [attendingItems, setAttendingItems] = useState();
  const [invitedItems, setInvitedItems] = useState();
  const [notInvitedItems, setNotInvitedItems] = useState();
  const [activeListItems, setActiveListItems] = useState([]);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleBan = (item) => {
    onBan && onBan(item);
  };
  const handleDelete = (item) => {
    onDelete && onDelete(item);
  };
  const handleRoleEdit = (item) => {
    onRoleEdit && onRoleEdit(item);
    setSelectedTab(tabs.INVITED);
  };
  const handleShowNote = (item) => {
    onShowNote && onShowNote(item);
  };

  const handlePromote = async (item, promotionType) => {
    if (onPromote) return await onPromote(item, promotionType);
  };

  useEffect(() => {
    if (items) {
      const _invitedItems = [];
      const _attendingItems = [];
      const _notInvitedItems = [];
      items.map((item) => {
        const parsedItem = {
          ...item,
          cardTitle: item.user.email,
        };
        if (item.status === breakoutRoomInviteModel.enums.status.ACCEPTED) {
          !item?.withoutTicket
            ? _attendingItems.push(parsedItem)
            : _notInvitedItems.push(parsedItem);
        } else {
          _invitedItems.push(parsedItem);
        }
      });
      setAttendingItems(_attendingItems);
      setInvitedItems(_invitedItems);
      setNotInvitedItems(_notInvitedItems);
      setActiveListItems([..._invitedItems]);
    }
  }, [items]);

  useEffect(() => {
    if (items && attendingItems && invitedItems && notInvitedItems) {
      if (selectedTab === tabs.ATTENDING)
        setActiveListItems([...attendingItems]);
      else if (selectedTab === tabs.INVITED)
        setActiveListItems([...invitedItems]);
      else setActiveListItems([...notInvitedItems]);
    }
  }, [selectedTab]);

  const renderRow = (props) => {
    const { index, style } = props;
    const item = activeListItems[index];
    return (
      <div key={'item' + index} style={style}>
        <SmallerCard
          cardInformations={item}
          isSmDown={isSmDown}
          isXsDown={isXsDown}
          is320Down={is320Down}
          isPromotionEnabled={!isOnlyViewMode}
          onPromote={
            //TODO: rimettere questa logica
            item.status === breakoutRoomInviteModel.enums.status.ACCEPTED &&
            onPromote
              ? async (promotionType) => {
                  return await handlePromote(item, promotionType);
                }
              : null
          }
          onBan={
            item.status !== breakoutRoomInviteModel.enums.status.CANCELED &&
            item.status !== breakoutRoomInviteModel.enums.status.REJECTED &&
            !isOnlyViewMode
              ? () => {
                  handleBan(item);
                }
              : null
          }
          onShowNote={
            item.status === breakoutRoomInviteModel.enums.status.REJECTED
              ? () => {
                  handleShowNote(item);
                }
              : null
          }
          onDelete={
            isOnlyViewMode
              ? null
              : () => {
                  handleDelete(item);
                }
          }
          onRoleEdit={
            item.status === breakoutRoomInviteModel.enums.status.ACCEPTED &&
            onRoleEdit
              ? handleRoleEdit
              : null
          }
        />
      </div>
    );
  };

  const fetchTabsValue = (value) => {
    if (value === tabs.ATTENDING) return attendingItems.length;
    else if (value === tabs.INVITED) return invitedItems.length;
    else return notInvitedItems.length;
  };

  return (
    <div style={{ width: '100%' }}>
      {items && attendingItems && invitedItems && notInvitedItems ? (
        <>
          <div>
            <Tabs value={selectedTab} onChange={handleChangeTab}>
              {Object.values(tabs).map((value) => {
                return (
                  <Tab
                    label={`${i18n.tabs[value]} (${fetchTabsValue(value)})`}
                    value={value}
                    key={value}
                  />
                );
              })}
            </Tabs>
          </div>
          <ListContainer>
            <FixedSizeList
              height={
                isXsDown
                  ? listDimensions.big.itemSize *
                    listDimensions.big.listMinCount
                  : listDimensions.small.itemSize *
                    listDimensions.small.listMinCount
              }
              itemSize={
                isXsDown
                  ? listDimensions.big.itemSize
                  : listDimensions.small.itemSize
              }
              itemCount={activeListItems.length}
            >
              {renderRow}
            </FixedSizeList>
          </ListContainer>
        </>
      ) : null}
    </div>
  );
}

export default InvitationList;
